export default "__VITE_ASSET__uOLx3AGA__"